"use client"

import { useEffect } from "react"
import { captureAttribution } from "../lib/attribution"

/**
 * Renders nothing. Exists only to run the capture once, on arrival, before the
 * referrer is lost to the first internal navigation. Mounted in the root layout
 * so it covers every route, including the ones a model is most likely to link
 * to directly, which are the guides and `/sobre` rather than the home page.
 */
export function AttributionCapture() {
  useEffect(() => {
    const attribution = captureAttribution()

    const gtag = (window as Window & { gtag?: (...args: unknown[]) => void }).gtag

    // Sent as its own event so the channel is queryable in GA4 without waiting
    // for a lead. Most visits never convert, and knowing that AI sent thirty
    // people who did not write is worth as much as knowing one did.
    if (gtag && attribution.channel) {
      gtag("event", "visita_atribuida", {
        canal: attribution.channel,
        referrer_host: attribution.referrer_host ?? "",
        landing_path: attribution.landing_path ?? "",
      })
    }
  }, [])

  return null
}
